import React from "react";
import { Identifiable, Resource } from "@planzone/dto";

enum ExpressionTypes {
  TEXT = "text",
  RESOURCE = "resource",
}

type Expression = {
  type: ExpressionTypes;
  content: string;
  attributes: Attribute;
};

type Attribute = {
  url?: string;
  childNodes?: Expression[];
};

type Replacement = (content: string, attributes: Attribute) => React.ReactNode;

type Processor = {
  type: ExpressionTypes;
  process(expr: Expression): Expression[];
};

interface Props {
  content: string;
  resources: Identifiable<Resource>[];
  replacements: { [key in ExpressionTypes]: Replacement };
}

export type { Props, Expression, Processor, Replacement };

export { ExpressionTypes };
